/**
 * Prefetch dashboard data after login.
 *
 * Warms the TanStack Query cache so the dashboard renders instantly.
 * Fire-and-forget — errors are silently ignored (dashboard hooks will retry).
 */

import type { QueryClient } from '@tanstack/react-query';
import { getViews, getViewTasks, getProjects, getLabels } from '../api/client';

export function prefetchDashboardData(queryClient: QueryClient): void {
  // Prefetch projects and labels immediately (no dependencies)
  queryClient.prefetchQuery({ queryKey: ['projects'], queryFn: getProjects });
  queryClient.prefetchQuery({ queryKey: ['labels'], queryFn: getLabels });

  // Prefetch views, then prefetch tasks for each view
  queryClient.prefetchQuery({ queryKey: ['views'], queryFn: getViews }).then(() => {
    const views = queryClient.getQueryData<{ slug: string }[]>(['views']);
    if (!views) return;

    for (const view of views) {
      queryClient.prefetchQuery({
        queryKey: ['tasks', view.slug, false],
        queryFn: () => getViewTasks(view.slug, { includeCompleted: false }),
      });
    }
  });
}
